import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-537805f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isLoading = ref(true);
const store = useStore();

onBeforeMount(async () => {
  isLoading.value = true;
  try {
    await store.dispatch('provision/receiveOnlyOptional');
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : _createCommentVNode("", true)
}
}

})